import { render, staticRenderFns } from "./editCustomer.vue?vue&type=template&id=65ea4c61"
import script from "./editCustomer.vue?vue&type=script&lang=js"
export * from "./editCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports